import classnames from 'classnames';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '~/components/button';
import ButtonGroup from '~/form_components/button_group';
import DropdownButton from '~/form_components/dropdown_button';
import { useUser } from '~/providers/user';
import { useWebsocket } from '~/providers/websocket';
import { getOrCreateDocumentComparison, } from '~/redux/reducers/states/comparison_documents/actions';
import Permissions from '~/settings/permissions';
import { useContentLibrary } from '../../../providers/content_library_provider';
const OldButtonsContainer = (props) => {
    const { setIsDownloadModalVisible, setIsAddToProjectModalOpen } = props;
    const { hasPermission } = useUser();
    const dispatch = useDispatch();
    const { selectedDocuments, clearSelectedDocuments } = useContentLibrary();
    const creatingDocumentComparison = useSelector((state) => state.comparisonDocumentsState.creatingDocumentComparison);
    const navigate = useNavigate();
    const ws = useWebsocket();
    const [isDropdownMenuExpanded, setIsDropdownMenuExpanded] = useState(false);
    const compareButtonClass = classnames('selected-documents-button', {
        'btn-focus': isDropdownMenuExpanded,
    });
    let actionButton = 'Compare';
    if (creatingDocumentComparison) {
        actionButton = '';
    }
    else if ((selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) === 1) {
        if (hasPermission(Permissions.DOWNLOAD_DOCUMENT)) {
            actionButton = 'Download';
        }
        else if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
            actionButton = 'Add to Folder';
        }
    }
    const handleCreateDocumentComparison = () => {
        dispatch(getOrCreateDocumentComparison({
            fileIds: selectedDocuments.map(doc => doc.id),
            ws,
            navigate,
        }));
    };
    const menuItems = useMemo(() => {
        const menu = [];
        if (hasPermission(Permissions.DOWNLOAD_DOCUMENT)) {
            menu.push({
                key: 'download',
                name: 'Download Documents',
            });
        }
        if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
            menu.push({
                key: 'addToFolder',
                name: 'Add to Folder',
            });
        }
        return menu;
    }, [hasPermission]);
    const onItemClick = (item) => {
        if ((selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) > 0) {
            if (item === 'download') {
                onDownloadOptionClick();
            }
            else if (item === 'addToFolder') {
                setIsAddToProjectModalOpen(true);
            }
        }
    };
    const onDropdownButtonMenuToggle = (isOpen) => {
        setIsDropdownMenuExpanded(isOpen);
    };
    const onDownloadOptionClick = () => {
        setIsDownloadModalVisible(true);
    };
    const handleActionButtonClick = () => {
        if ((selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) === 1) {
            if (hasPermission(Permissions.DOWNLOAD_DOCUMENT)) {
                onDownloadOptionClick();
            }
            else if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
                setIsAddToProjectModalOpen(true);
            }
        }
        else if ((selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) > 1) {
            handleCreateDocumentComparison();
        }
    };
    const showSplitActionButton = (menuItems.length > 0 && (selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) > 1) ||
        (menuItems.length > 1 && (selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) > 0);
    const ActionButton = () => (React.createElement(Button, { "data-testid": 'compare-selected-documents-button', className: compareButtonClass, id: 'compare-documents-button', onClick: () => handleActionButtonClick(), disabled: !(selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) ||
            !!creatingDocumentComparison ||
            (!menuItems.length && (selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) < 2) },
        actionButton,
        creatingDocumentComparison &&
            React.createElement("span", { "data-testid": 'creating-document-comparison-spinner' },
                React.createElement("i", { className: 'fas fa-spin fa-spinner' }))));
    return React.createElement("div", { className: 'buttons-container' },
        React.createElement(Button, { "data-testid": 'clear-selected-documents-button', secondary: true, className: 'selected-documents-button clear', onClick: clearSelectedDocuments, id: 'clear-documents-button' },
            React.createElement("span", null,
                React.createElement("i", { className: 'far fa-trash-alt' })),
            React.createElement("span", { className: 'clear-text' }, "Clear")),
        !showSplitActionButton && (React.createElement(ActionButton, null)),
        showSplitActionButton && (React.createElement(ButtonGroup, null,
            React.createElement(ActionButton, null),
            React.createElement(DropdownButton, { className: 'dropdown-menu-button', onMenuItemClick: onItemClick, title: '', menuItems: menuItems, disabled: !((selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) > 0) || !menuItems.length, onMenuToggle: onDropdownButtonMenuToggle }))));
};
export default OldButtonsContainer;
